import { CSSProperties } from 'react';

export const errorMessageStyles: CSSProperties = {
  fontSize: '12px',
  color: '#EA3A3D',
};
